import { omit } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

import { GqlCourseCreateInput, GqlCourseUpdateInput } from "~/__generated__";
import GaiaDeleteButton from "~/modules/app/components/GaiaDeleteButton";
import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import ErrorScreen from "~/modules/app/screens/ErrorScreen";

import CourseForm from "../../components/CourseForm";
import useCourseEditRoute_Delete from "./api/useCourseEditRoute_Delete";
import useCourseEditRoute_GetById from "./api/useCourseEditRoute_GetById";
import useCourseEditRoute_Update from "./api/useCourseEditRoute_Update";

export default function CourseEditRoute() {
    const { t } = useTranslation("course");
    const { courseId } = useParams();
    const navigate = useNavigate();

    if (!courseId) throw Error("No courseId param in url");

    const { data, loading, error } = useCourseEditRoute_GetById(courseId);
    const { updateCourse, error: updateError } = useCourseEditRoute_Update();
    const { deleteCourse, loading: deleteLoading } = useCourseEditRoute_Delete();

    const handleSubmit = async (formData: GqlCourseCreateInput | GqlCourseUpdateInput) => {
        const result = await updateCourse(courseId, formData);

        if (result.data?.courseUpdate) {
            navigate("..", { replace: true });
        }
    };

    const handleDelete = async () => {
        await deleteCourse(courseId);
        navigate("..", { replace: true });
    };

    if (error) {
        return <ErrorScreen error={error} />;
    }

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("courseEditScreen.title")} isLoading={loading}>
                {data && <CourseForm courseData={omit(data, ["id", "__typename"])} onSubmit={handleSubmit} error={updateError} />}
            </GaiaPageComponent>
            <GaiaPageComponent title={t("courseEditScreen.dangertitle")} titleVariant="h3">
                {data && (
                    <GaiaDeleteButton
                        label={t("courseDeleteButton.btnDelete")}
                        isLoading={deleteLoading}
                        onDelete={handleDelete}
                    />
                )}
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
